import styled from '@emotion/styled';
import {colors} from 'patient-ping-remedy/packages/theme';

export const ViewAttempt = styled.button`
  color: ${colors.blue4};
  font-size: inherit;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;
